<template>
  <vx-card class="mt-base mb-5">
    <heading size="h1" style-size="h4" class="mb-5"
      >You haven't completed the Prework activities</heading
    >
    <p class="mb-5">Some intro text here?</p>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/5 mb-base"></div>

      <div class="vx-col w-full lg:w-1/5 sm:w-1/3 xs:w-full mb-base text-center">
        <h5>Workplace Safety</h5>
        <status-icon
          :type="sectionWS ? 'completed' : 'not_completed'"
          class="prework_icon my-5"
        /><br />
        <router-link
          to="/student/workplace-safety"
          v-if="!sectionWS"
          class="btn btn-primary btn-size-small"
          >Open Section</router-link
        >
      </div>
      <div class="vx-col w-full lg:w-1/5 sm:w-1/3 xs:w-full mb-base text-center">
        <h5>Workplace Preparation</h5>
        <status-icon
          :type="sectionWP ? 'completed' : 'not_completed'"
          class="prework_icon my-5"
        /><br />
        <router-link
          to="/student/workplace-preparation"
          v-if="!sectionWP"
          class="btn btn-primary btn-size-small"
          >Open Section</router-link
        >
      </div>
      <div class="vx-col w-full lg:w-1/5 sm:w-1/3 xs:w-full mb-base text-center">
        <h5>Apply for a Position</h5>
        <status-icon
          :type="sectionApply ? 'completed' : 'not_completed'"
          class="prework_icon my-5"
        /><br />
        <router-link to="/student/apply" v-if="!sectionApply" class="btn btn-primary btn-size-small"
          >Open Section</router-link
        >
      </div>

      <div class="vx-col w-full lg:w-1/5 mb-base"></div>
    </div>
  </vx-card>
</template>

<script>
import store from '@/store/store';
import StatusIcon from '@/components/UI/StatusIcon';
export default {
  data() {
    return {
      sectionWS: false,
      sectionWP: false,
      sectionApply: false,
    };
  },
  components: { StatusIcon },
  computed: {
    prework() {
      return store.getters['authStudent/prework'];
    },
  },
  watch: {
    prework() {
      if (this.prework.status) {
        this.sectionWS =
          typeof this.prework !== 'undefined' &&
          this.prework !== null &&
          this.prework.status.section_ws;
        this.sectionWP =
          typeof this.prework !== 'undefined' &&
          this.prework !== null &&
          this.prework.status.section_wp;
        this.sectionApply =
          typeof this.prework !== 'undefined' &&
          this.prework !== null &&
          this.prework.status.section_apply;
      }
    },
  },
  mounted() {
    if (this.prework) {
      this.sectionWP =
        typeof this.prework !== 'undefined' &&
        this.prework !== null &&
        this.prework.status.section_wp;
      this.sectionWS =
        typeof this.prework !== 'undefined' &&
        this.prework !== null &&
        this.prework.status.section_ws;
      this.sectionApply =
        typeof this.prework !== 'undefined' &&
        this.prework !== null &&
        this.prework.status.section_apply;
    }
  },
};
</script>

<style>
.prework_icon .status_icon {
  width: 40px !important;
  height: 40px !important;
}
</style>
